import React, {useCallback} from 'react';
import {useRouter} from 'next/router';

import {Button, Icon, Modal, TallyLogo, Text} from '#component/base';
import {useViewportSize} from '#hook';

import * as css from './ActionPlanActivatedModal.css';

export function ActionPlanActivatedModal() {
  const {isDesktop} = useViewportSize();
  const {reload, push, pathname} = useRouter();

  const navigateToActionPlan = useCallback(() => {
    if (pathname === '/actionplan') {
      reload();
    } else {
      push('/actionplan');
    }
  }, [pathname, push, reload]);

  return (
    <Modal layout="fullScreen" variant="dark" hideCloseButton>
      <TallyLogo color="cotton" size={72} className={css.logo} />
      <div className={css.layout}>
        <div className={css.content}>
          <div className={css.text}>
            <Icon name="Confetti" size={74} color={'apricot'} weight="thin" />
            <Text
              as="h1"
              variant={isDesktop ? 'heading2' : 'heading1'}
              color="white"
              fontWeight="light">
              Your plan is activated!
            </Text>
          </div>
          <Button onClick={navigateToActionPlan} variant="primary-dark" className={css.button}>
            View my Action Plan
          </Button>
        </div>
      </div>
    </Modal>
  );
}
